@if (!alarmEvent?.AckTime) {
  <div
    class="alarm-indicator unacked"
  >
    unacknowledged

    @if (alarmMenuOptions) {
      <motn-popover-menu
        [optionGroup]="alarmMenuOptions"
        (clickedOption$)="emitClicked()"
        (clickedOutsideMenu$)="emitClicked()"
      ></motn-popover-menu>
    }
  </div>
}

@if (alarmEvent?.AckTime) {
  <div
    class="alarm-indicator acked"
  >
    acknowledged

    @if (alarmMenuOptions) {
      <motn-popover-menu
        [optionGroup]="alarmMenuOptions"
        (clickedOption$)="emitClicked()"
        (clickedOutsideMenu$)="emitClicked()"
      ></motn-popover-menu>
    }
  </div>
}
